import React from 'react';
import WizardInputSkeleton from '../epd-wizard-inputs/WizardInputSkeleton';
import { Skeleton } from 'primereact/skeleton';

const SelectorButtonSkeleton: React.FC = () => {
  return (
    <div>
      <WizardInputSkeleton />
      <Skeleton width="5rem" className="mt-2" />
    </div>
  );
};

export default SelectorButtonSkeleton;
